import { Category } from '@/types';
import { COLORS } from './colors';

export const DEFAULT_CATEGORIES: Omit<Category, 'id'>[] = [
  {
    userId: null,
    name: 'Deep Work',
    color: COLORS.deepWork,
    icon: null,
    isDefault: true,
    order: 0,
  },
  {
    userId: null,
    name: 'Shallow Work',
    color: COLORS.shallow,
    icon: null,
    isDefault: true,
    order: 1,
  },
  {
    userId: null,
    name: 'Personal',
    color: COLORS.personal,
    icon: null,
    isDefault: true,
    order: 2,
  },
  {
    userId: null,
    name: 'Meeting',
    color: COLORS.meeting,
    icon: null,
    isDefault: true,
    order: 3,
  },
  {
    userId: null,
    name: 'Buffer',
    color: COLORS.buffer,
    icon: null,
    isDefault: true,
    order: 4,
  },
];

export const CATEGORY_COLORS = [
  COLORS.deepWork,
  COLORS.shallow,
  COLORS.personal,
  COLORS.meeting,
  COLORS.buffer,
  COLORS.urgent,
  '#dd6b20', // orange dark
  '#d69e2e', // yellow
  '#319795', // teal
  '#805ad5', // purple dark
];

export const DURATION_OPTIONS = [
  { label: '15m', value: 15 },
  { label: '30m', value: 30 },
  { label: '45m', value: 45 },
  { label: '1h', value: 60 },
  { label: '1.5h', value: 90 },
  { label: '2h', value: 120 },
];

export const PRIORITY_OPTIONS = [
  { label: 'Low', value: 'low' as const },
  { label: 'Medium', value: 'medium' as const },
  { label: 'High', value: 'high' as const },
];
